<template>
    <div class="base-smart-countdown">
        <div
            v-if="!hideDays"
            class="base-smart-countdown__time-unit base-smart-countdown__days"
        >
            <span>
                {{ remaningTime.days }}
            </span>
            <span
                v-if="hasTexts"
                class="base-smart-countdown__time-unit-text"
            >
                {{ $t(`${textDays}`) }}
            </span>
        </div>
        <div
            v-if="!hideHours"
            class="base-smart-countdown__time-unit base-smart-countdown__hours"
        >
            <span>
                {{ remaningTime.hours }}
            </span>
            <span
                v-if="hasTexts"
                class="base-smart-countdown__time-unit-text"
            >
                {{ $t(`${textHours}`) }}
            </span>
        </div>
        <div
            v-if="!hideMinutes"
            class="base-smart-countdown__time-unit base-smart-countdown__minutes"
        >
            <span>
                {{ remaningTime.minutes }}
            </span>
            <span
                v-if="hasTexts"
                class="base-smart-countdown__time-unit-text"
            >
                {{ $t(`${textMinutes}`) }}
            </span>
        </div>
        <div
            v-if="!hideSeconds"
            class="base-smart-countdown__time-unit base-smart-countdown__seconds"
        >
            <span>
                {{ remaningTime.seconds }}
            </span>
            <span
                v-if="hasTexts"
                class="base-smart-countdown__time-unit-text"
            >
                {{ $t(`${textSeconds}`) }}
            </span>
        </div>
    </div>
</template>

<script>
    import Countdown from '../../domain/countdown';

    export default {
        name: 'BaseSmartCountdown',

        props: {
            timeStamp: {
                type: Number,
                default: new Date().getTime() + 1,
                required: true,
            },

            intervalRefresh: {
                type: Number,
                default: 1000
            },

            hasTexts: {
                type: Boolean,
                default: false
            },

            hideDays: {
                type: Boolean,
                default: false
            },

            hideHours: {
                type: Boolean,
                default: false
            },

            hideMinutes: {
                type: Boolean,
                default: false
            },

            hideSeconds: {
                type: Boolean,
                default: false
            },
            textDays: {
                type: String,
                default: 'countdown.days',
            },
            textHours: {
                type: String,
                default: 'countdown.hours',
            },
            textMinutes: {
                type: String,
                default: 'countdown.minutes',
            },
            textSeconds: {
                type: String,
                default: 'countdown.seconds',
            },
        },

        data() {
            return {
                countdown: new Countdown({
                    timeStamp: this.timeStamp,
                    refreshTime: this.intervalRefresh
                }),
                interval: null,
            }
        },

        computed: {
            remaningTime() {
                return this.countdown.remainingTimeObject() || {};
            },

            timeEnds() {
                return this.countdown.timeEnd();
            }
        },

        watch: {
            timeStamp(newValue) {
                this.countdown.updateCountdown(newValue);
            }
        },

        mounted() {
            this.interval = setInterval(() => {
                if (this.timeEnds) {
                    clearInterval(this.interval);
                    this.$emit('onTimeEnds');
                    return;
                }
                this.countdown.decrement();
            }, this.intervalRefresh);
        },

        beforeDestroy() {
            clearInterval(this.interval);
        }
    }
</script>

<style src="./BaseSmartCountdown.scss" lang="scss"></style>
